<script>
  import { tooltip } from "svelte-utilities";

  import { createEventDispatcher } from "svelte";
  import DuplicateIcon from "@local/assets/icons/duplicate.svg";
  import DuplicateSendIcon from "@local/assets/icons/duplicate-send.svg";
  import LocationCloneIcon from "@local/assets/icons/location-item-clone-multiple.svg";
  import HideIcon from "@local/assets/icons/hide.svg";
  import IsolateIcon from "@local/assets/icons/isolate.svg";
  import ShowIcon from "@local/assets/icons/show.svg";
  import TempHideIcon from "@local/assets/icons/temp-hide.svg";
  import TempShowIcon from "@local/assets/icons/temp-show.svg";
  import QuickSelectIcon from "@local/assets/icons/quick-select.svg";
  import ZoomSelectedIcon from "@local/assets/icons/zoom-selected.svg";
  import RenameIcon from "@local/assets/icons/rename.svg";
  import MergeIcon from "@local/assets/icons/merge.svg";
  import UnmergeIcon from "@local/assets/icons/un-merge.svg";
  import SplitIcon from "@local/assets/icons/split.svg";
  import XIcon from "@local/assets/icons/x.svg";
  import LinkIcon from "@local/assets/icons/link.svg";
  import DownloadIcon from "@local/assets/icons/download.svg";
  import TrashIcon from "@local/assets/icons/trash.svg";
  import AlignVerticalIcon from "@local/assets/icons/align-vertical.svg";
  import AlignHorizontalIcon from "@local/assets/icons/align-horizontal.svg";
  import DistributeHorixontalIcon from "@local/assets/icons/distribute-horizontal.svg";
  import DistributeVerticalIcon from "@local/assets/icons/distribute-vertical.svg";
  import ImageIcon from "@local/assets/icons/image.svg";

  const dispatch = createEventDispatcher();

  export let cloneable = false;
  export let locationcloneable = false;
  export let downloadable = false;
  export let deletable = false;
  export let shareable = false;
  export let hideable = false;
  export let temphideable = false;
  export let isolatable = false;
  export let selectable = false;
  export let mergeable = false;
  export let zoomable = false;
  export let linkable = false;
  export let hidden = false;
  export let temphidden = false;
  export let remarkable = false;
  export let positionable = false;
  export let imageable = false;
  export let splittable = false;
  export let selected = 1;
  export let hordistributable = false;
  export let verdistributable = false;
  export let hideLabel = "Hide";
  export let showLabel = "Show";
  export let tempHideLabel = "Temporarily Hide";
  export let tempShowLabel = "Show Temporarily Hidden";
  export let isolateLabel = "Isolate";

  $: actionable =
    cloneable ||
    locationcloneable ||
    deletable ||
    shareable ||
    hideable ||
    temphideable ||
    isolatable ||
    selectable ||
    mergeable ||
    zoomable ||
    linkable ||
    positionable ||
    imageable;

  function toggleHidden() {
    if (hidden) {
      dispatch("show");
    } else {
      dispatch("hide");
    }
  }

  function toggleTempHidden() {
    if (temphidden) {
      dispatch("temp-show");
    } else {
      dispatch("temp-hide");
    }
  }
</script>

{#if actionable}
  <div class="w-full flex justify-center absolute p-4 z-30 pointer-events-none selected-actions-popover">
    <div class="flex items-start bg-white p-2 rounded border shadow-lg pointer-events-auto">
      <div class="text-xs px-2 py-1 mr-1 text-right">
        {#if downloadable}
          <button
            class="mini-button flex gap-1"
            on:click|stopPropagation={(e) => dispatch("download")}
            use:tooltip={{ text: "Download selected" }}>
            <DownloadIcon />
            {selected} selected
          </button>
        {:else}
          <div>{selected} selected</div>
        {/if}
      </div>
      <div class="flex flex-col items-start gap-2">
        <div class="flex items-center gap-1">
          {#if cloneable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("clone")}
              use:tooltip={{ text: "Clone" }}>
              <DuplicateIcon />
            </button>
          {/if}
          {#if locationcloneable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("clone-locations")}
              use:tooltip={{ text: "Place Markers" }}>
              <LocationCloneIcon />
            </button>
          {/if}
          {#if shareable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("share")}
              use:tooltip={{ text: "Send" }}>
              <DuplicateSendIcon />
            </button>
          {/if}
          {#if hideable}
            <button
              class="mini-button"
              on:click|stopPropagation={toggleHidden}
              use:tooltip={{ text: hidden ? showLabel : hideLabel }}>
              {#if hidden}
                <HideIcon />
              {:else}
                <ShowIcon />
              {/if}
            </button>
          {/if}
          {#if temphideable}
            <button
              class="mini-button"
              on:click|stopPropagation={toggleTempHidden}
              use:tooltip={{ text: temphidden ? tempShowLabel : tempHideLabel }}>
              {#if temphidden}
                <TempHideIcon />
              {:else}
                <TempShowIcon />
              {/if}
            </button>
          {/if}
          {#if isolatable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("isolate")}
              use:tooltip={{ text: isolateLabel }}>
              <IsolateIcon />
            </button>
          {/if}
          {#if selectable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("select-similar")}
              use:tooltip={{ text: "Select Similar" }}>
              <QuickSelectIcon />
            </button>
          {/if}
          {#if mergeable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("merge")}
              use:tooltip={{ text: "Merge" }}>
              <MergeIcon />
            </button>
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("un-merge")}
              use:tooltip={{ text: "Un-merge" }}>
              <UnmergeIcon />
            </button>
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("mark-void")}
              use:tooltip={{ text: "Mark as Void" }}>
              <XIcon />
            </button>
          {/if}
          {#if zoomable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("zoom-selected")}
              use:tooltip={{ text: "Zoom Selected (Z)" }}>
              <ZoomSelectedIcon />
            </button>
          {/if}
          {#if linkable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("link")}
              use:tooltip={{ text: "Link" }}>
              <LinkIcon />
            </button>
          {/if}
          {#if remarkable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("remark")}
              use:tooltip={{ text: "Update Mark (M)" }}>
              <RenameIcon />
            </button>
          {/if}
          {#if imageable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("set-thumbnail")}
              use:tooltip={{ text: "Set Document Thumbnail" }}>
              <ImageIcon />
            </button>
          {/if}
          {#if hordistributable && selected > 2}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("distribute-horizontal")}
              use:tooltip={{ text: "Distribute Horizontally" }}>
              <DistributeHorixontalIcon />
            </button>
          {/if}
          {#if verdistributable && selected > 2}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("distribute-vertical")}
              use:tooltip={{ text: "Distribute Vertically" }}>
              <DistributeVerticalIcon />
            </button>
          {/if}
          {#if splittable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("split")}
              use:tooltip={{ text: "Split at Gridline" }}>
              <SplitIcon />
            </button>
          {/if}
          {#if deletable}
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("delete")}
              use:tooltip={{ text: "Delete" }}>
              <TrashIcon />
            </button>
          {/if}
        </div>
        {#if positionable && selected > 1}
          <div class="flex items-center gap-1">
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("align-horizontal")}
              use:tooltip={{ text: "Align Horizontally" }}>
              <AlignHorizontalIcon />
            </button>
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("align-vertical")}
              use:tooltip={{ text: "Align Vertically" }}>
              <AlignVerticalIcon />
            </button>
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("distribute-horizontal")}
              use:tooltip={{ text: "Distribute Horizontally" }}>
              <DistributeHorixontalIcon />
            </button>
            <button
              class="mini-button"
              on:click|stopPropagation={(e) => dispatch("distribute-vertical")}
              use:tooltip={{ text: "Distribute Vertically" }}>
              <DistributeVerticalIcon />
            </button>
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .mini-button {
    @apply p-1 rounded;

    &:hover {
      @apply bg-gray-200;
    }
  }
</style>
